import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/storage-hub/capture-storage/database/$id/settings")({
  staticData: {
    title: "common.settings",
  },
});
